import { createSelector } from 'reselect'
import moment from 'moment'

function convertOrderBedbankItemToCartItem(orderItem: App.OrderBedbankItem): App.Checkout.BedbankHotelItem {
  return {
    itemType: 'bedbankHotel',
    itemId: orderItem.id,
    transactionKey: orderItem.transactionKey,
    offerId: orderItem.offer.id,
    checkIn: moment(orderItem.checkIn).format('YYYY-MM-DD'),
    checkOut: moment(orderItem.checkOut).format('YYYY-MM-DD'),
    duration: orderItem.duration,
    total: orderItem.total,
    roomId: orderItem.roomTypeId,
    roomRateId: orderItem.roomRateId,
    orderItemId: orderItem.id,
    orderId: orderItem.orderId,
    isFlightBundle: orderItem.rooms.some(room => room.isFlightBundle),
    bedGroupId: orderItem.rooms.find(room => room.bedGroup)?.bedGroup?.id ?? '',
    occupancy: orderItem.rooms.reduce((acc, room) => {
      acc.adults += room.occupancy.adults ?? 0
      acc.children += room.occupancy.children ?? 0
      acc.infants += room.occupancy.infants ?? 0
      return acc
    }, { adults: 0, children: 0, infants: 0 }),
    sessionId: undefined,
    originalItemId: undefined,
    rateGroupId: undefined,
    boardCode: undefined,
    refundable: orderItem.rooms.every(room => room.refundable),
  }
}

const getBedbankOrderItems = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (existingOrder): Array<App.Checkout.BedbankHotelItem> => {
    if (!existingOrder?.bedbankItems) {
      return []
    }

    return existingOrder.bedbankItems.map(orderItem =>
      convertOrderBedbankItemToCartItem(orderItem),
    )
  },
)

export default getBedbankOrderItems
